import { InjectionToken } from "@angular/core";

export const WINDOW_INJECTION_TOKEN = new InjectionToken<Window>('Window');
